import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DtAnCreditapplicationLibComponent } from './dt-an-creditapplication-lib.component';
const routes: Routes = [
  {
    path: '',
    component: DtAnCreditapplicationLibComponent,
    pathMatch: 'full'
  },
  {
    path: '**',
    component: DtAnCreditapplicationLibComponent,
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
